import { ReactNode } from 'react';

import {
    KameleoonProvider,
    SDKConfigurationType,
    createClient,
} from '@kameleoon/react-sdk';
import mixpanel from 'mixpanel-browser';

const configuration: Partial<SDKConfigurationType> = {
    environment: window?._env_?.ENV?.toLowerCase(),
    updateInterval: 10,
};

export const kameleoonClient = createClient({
    siteCode: 'jr6r0n042f',
    configuration,
});

export const KameleeonProvider = ({ children }: { children: ReactNode }) => {
    return (
        <KameleoonProvider client={kameleoonClient}>
            {children}
        </KameleoonProvider>
    );
};

export enum KAMELEOON_FEATURE {
    a2_defer = 'a2_defer',
    call_booking_redesign = 'call_booking_redesign',
}

export const sendFeatureToMixPanel = (
    variant: string | null,
    feature: string,
) => {
    if (variant?.startsWith('variant')) {
        if (mixpanel) {
            mixpanel.track(`Test - ${feature}`, { variant: variant });
        }
    }
};
